/**
 * Shared shadow-root CSS for the global all-caps toggle (@tl4k/admin-ui).
 * The UA stylesheet sets text-transform: none on button/select, so light-DOM
 * rules cannot reach them. Prepend this string to every shadow-root template.
 * `inherit` keeps the current look when all-caps is off.
 */
export const allCapsShadowCss = `<style>
button, select, option {
  text-transform: inherit;
}
</style>
`
